import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = { style: {"border-top":"1px solid var(--ion-color-dark)"} }
const _hoisted_3 = { class: "divider" }

import { getDeviceUuid } from "@/services/deviceId";
import { CustomElement, TmpList, UserType } from "@/types";
import { getCurrentElement, getCustomMessage, getIcon } from "@/utils";
import {
  IonCard,
  //IonCardHeader,
  IonCardContent,
  //IonCardTitle,
  IonItem,
  IonInput,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
} from "@ionic/vue";
import { reactive, Ref, ref } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthPanel',
  emits: ["login", "execute_link"],
  async setup(__props) {

let __temp: any, __restore: any

const changeType = (type: UserType) => {
  /*for (const key in user_information[login_type.value]) {
    if (user_information[type] != undefined) {
      user_information[type][key] = user_information[login_type.value][key];
    }
    user_information[login_type.value][key] = "";
  }*/
  login_type.value = type;
};
const takeParameters = () => {
  for (const info of user_information[login_type.value]) {
    actual_params[info] = params[info];
  }
  for (const key of Object.keys(params)) {
    params[key] = "";
  }
};


const store = useStore();

const login_type: Ref<UserType> = ref("student");
const user_information: {
  [key in keyof string as UserType]: string[];
} = {
  student: ["username", "password"],
  teacher: ["username", "password"],
  admin: ["username", "password"],
};
const params: TmpList<any> = reactive({
  username: "",
  password: "",
});
const actual_params: TmpList<any> = {
  device_uuid: (
  ([__temp,__restore] = _withAsyncContext(() => getDeviceUuid())),
  __temp = await __temp,
  __restore(),
  __temp
),
};
const alternatives_login: CustomElement[] = [
  {
    //<!-- TODO (5): rendering bottone da telefono non coincide con parte cliccabile
    id: "google",
    type: "string_icon",
    linkType: "request",
    content: {
      icon: getIcon("google"),
      text: getCurrentElement("google"),
      order: true,
      whole_link: true,
      url: `/auth/google?user_uuid=${actual_params.device_uuid}`,
      method: "get",
    },
    ...store.state.button_css,
  },
];
const or = getCustomMessage("or", getCurrentElement("or"), "title");
or.colors = {
  background: {
    name: "white",
    type: "var",
  },
};
or.classes = {
  label: {
    "divider-title": true,
  },
};

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonCard), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardContent), null, {
          default: _withCtx(() => [
            (login_type.value == 'student')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        modelValue: params.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((params.username) = $event)),
                        type: "text",
                        label: _unref(getCurrentElement)('username')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        modelValue: params.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((params.password) = $event)),
                        type: "password",
                        label: _unref(getCurrentElement)('password')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ], 64))
              : (login_type.value == 'teacher')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: params.username,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((params.username) = $event)),
                          type: "text",
                          label: _unref(getCurrentElement)('username')
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: params.password,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((params.password) = $event)),
                          type: "password",
                          label: _unref(getCurrentElement)('password')
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : (login_type.value == 'admin')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonInput), {
                            modelValue: params.username,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((params.username) = $event)),
                            type: "text",
                            label: _unref(getCurrentElement)('username')
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonInput), {
                            modelValue: params.password,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((params.password) = $event)),
                            type: "password",
                            label: _unref(getCurrentElement)('password')
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
            _createVNode(_unref(IonButton), {
              onClick: _cache[6] || (_cache[6] = ($event: any) => {
            takeParameters();
            _ctx.$emit('login', {
              type: login_type.value,
              parameters: actual_params,
            });
          }),
              expand: "block",
              class: "ion-margin-vertical"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getCurrentElement)("login")), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (changeType('student'))),
                            expand: "block",
                            color: "primary",
                            fill: login_type.value == 'student' ? 'solid' : 'outline'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getCurrentElement)("student")), 1)
                            ]),
                            _: 1
                          }, 8, ["fill"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (changeType('teacher'))),
                            expand: "block",
                            color: "primary",
                            fill: login_type.value == 'teacher' ? 'solid' : 'outline'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getCurrentElement)("teacher")), 1)
                            ]),
                            _: 1
                          }, 8, ["fill"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (changeType('admin'))),
                            expand: "block",
                            color: "primary",
                            fill: login_type.value == 'admin' ? 'solid' : 'outline'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getCurrentElement)("admin")), 1)
                            ]),
                            _: 1
                          }, 8, ["fill"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ionic_element, { element: _unref(or) }, null, 8, ["element"])
            ]),
            _createVNode(_unref(IonGrid), { class: "ion-text-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: 
                  _unref(getCustomMessage)(
                    'login_with_account',
                    _unref(getCurrentElement)('login_with_account'),
                    'title'
                  )
                
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol)),
                    _createVNode(_unref(IonCol), { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: alternatives_login[0],
                          onExecute_link: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('execute_link')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})